import React from 'react'
import {Typography} from 'antd'
import {PageHeader, PaymentMethodLabelWithIcon} from '@/components'
import {PaymentMethodStoreSettings} from '@/pages/payment-methods/components'
import {PaymentMethodDetailsProps} from './props'
import {
    PAYMENT_METHOD_DESCRIPTION,
    PAYMENT_METHOD_TITLE
} from '@/constants/playwright-ids'

export const PaymentMethodDetails: React.FC<PaymentMethodDetailsProps> = (
    {stores, paymentMethodType, title, description}
) => {
    return <>
        <PageHeader
            title={(
                <PaymentMethodLabelWithIcon
                    paymentMethod={paymentMethodType}
                    bordered={true}
                    title={title}
                />
            )}
            border={'none'}
            data-test-id={PAYMENT_METHOD_TITLE}
        >
            <Typography.Text data-test-id={PAYMENT_METHOD_DESCRIPTION}>
                {description}
            </Typography.Text>
            <br/><br/>
            <PaymentMethodStoreSettings
                paymentMethodType={paymentMethodType}
                stores={stores}
            />
        </PageHeader>
    </>
}
